var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"homeContent",on:{"scroll":_vm.handelScroll}},[_c('summary-com',{ref:"dom",on:{"scrollTo":_vm.callbackScrollTo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }